class Agent {
  public readonly id: string;
  public readonly name: string;
  public readonly comment: string;
  public readonly permissions: { action: string; permission: boolean }[];

  constructor({
    id,
    name,
    comment,
    permissions,
  }: {
    id: string;
    name: string;
    comment: string;
    permissions: { action: string; permission: boolean }[];
  }) {
    this.id = id;
    this.name = name;
    this.comment = comment;
    this.permissions = permissions;
  }

  public static fromJSON = (value: any) => {
    const { id, name, comment, permissions } = Object.assign({}, value);

    return new Agent({
      id,
      name,
      comment,
      permissions,
    });
  };
}

export default Agent;
